import Logo from '@/components/Common/SideNavigation/Logo/Logo';
import COLORS from '@/constants/colors';
import { SIDE_NAV_WIDTH } from '@/utils/constants';
import Box from '@mui/material/Box';
import { VersionBadge } from '../VersionBadge/VersionBadge';
import { BottomMenu } from './BottomMenu/BottomMenu';
import { SideNavigationOptions } from './SideNavigationOptions/SideNavigationOptions';

export function SideNavigationMenu() {
  return (
    <nav>
      <Box
        data-testid="side-nav"
        sx={{
          backgroundColor: COLORS.white,
          width: `${SIDE_NAV_WIDTH}px`,
          padding: '23px 0 0',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          borderRight: `1px solid ${COLORS.purple_light}`,
        }}
      >
        <Box sx={{ px: 2, overflowY: 'auto', overscrollBehavior: 'contain' }}>
          <Box sx={{ justifyItems: 'center' }}>
            <Logo collapse={false} />
            <VersionBadge />
          </Box>
          <SideNavigationOptions />
        </Box>
        <Box sx={{ flexGrow: 1, display: 'flex' }} />
        <BottomMenu />
      </Box>
    </nav>
  );
}
